import { WhiteLabel } from 'pages/partners/pages/site_branding/interfaces';

export class API {

    private static async get(url: string) {

        const res = await fetch(url);
        return res.json();

    }

    private static async post(url: string, data: any) {

        return await fetch(url, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        }).then(res => res.json());

    }

    public static getpartnerWhiteLabels(partnerId: number, userId: number) {

        return this.get(`/Api/SiteBranding/GetpartnerWhiteLabels?partnerId=${partnerId}&userId=${userId}`);

    }

    public static createEditPartnerWhiteLabel(partnerId: number, userId: number, whiteLabel: WhiteLabel) {

        return this.post('/Api/SiteBranding/CreateEditPartnerWhiteLabel', {
            name: whiteLabel.Name,
            backgroundColor: whiteLabel.BackgroundColor,
            backgroundImage: whiteLabel.BackgroundImage,
            description: whiteLabel.Description,
            loginBackroundColor: whiteLabel.LoginBackgroundImage,
            partnerId,
            primaryColor: whiteLabel.Color1,
            primaryIcon: whiteLabel.PrimaryIcon,
            schoolPolicyText: whiteLabel.Policy,
            secondaryColor: whiteLabel.Color2,
            secondaryIcon: whiteLabel.SecondaryIcon,
            subdomain: whiteLabel.Subdomain,
            supportInfoText: whiteLabel.SupportString,
            tertiaryColor: whiteLabel.Color3,
            userId,
            whiteLabelId: whiteLabel.Id
        });

    }

}